import React, { Component } from 'react';
import { Query } from '@apollo/react-components';
import DashboardCard from '$components/ProductDashboard/DashboardCard';
import DashboardHeader from '$components/ProductDashboard/DashboardHeader';
import SpinnerError from '$components/library/SpinnerError';
import { gql } from '@apollo/client';
import styles from './styles.scss';

const QUOTE_OF_THE_MOMENT = gql`
  query QuoteOfTheMoment($input: QuoteOfTheMomentInput) {
    quoteOfTheMoment(input: $input) {
      text
      attribution
    }
  }
`;

class QuoteOfTheMoment extends Component {
  render() {
    const { productSlug } = this.props;
    return (
      <div>
        <DashboardHeader header="Quote of the moment" />
        <DashboardCard>
          <div className={styles.quoteBackground}>
            <i className="fas fa-quote-right" />
          </div>
          <Query query={QUOTE_OF_THE_MOMENT} variables={{ input: { productSlug } }}>
            {({ loading, error, data }) => {
              if (loading || error) {
                return <SpinnerError error={error} />;
              }

              const { quoteOfTheMoment } = data;
              const { attribution, text } = quoteOfTheMoment;

              return (
                <>
                  <div data-aaa="quoteText" className={styles.quoteText}>
                    {text}
                  </div>
                  <div className={styles.quoteAttribution}>{attribution}</div>
                </>
              );
            }}
          </Query>
        </DashboardCard>
      </div>
    );
  }
}

export default QuoteOfTheMoment;
